@if (!isLoading) {
  <div class="tw-flex tw-flex-col tw-gap-5">
    <section class="tw-border tw-border-divider">
      <app-accordion
        [headerClass]="'tw-bg-white hover:tw-bg-divider/20 disabled:hover:tw-bg-white tw-rounded-lg tw-text-left'"
        [isDisabled]="!portfolios.length"
        [isCollapsed]="portfolios.length"
      >
        <div accordion-title>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img
              src="../../../../../assets/img/icons/svgs/digital-cert.svg"
              alt="{{ 'settings.digitalCertificates' | translate }}"
              class="tw-h-5 tw-w-5"
            />
            <h3 class="tw-m-0 tw-font-body tw-text-sm tw-font-semibold tw-text-black">
              {{ 'settings.digitalCertificates' | translate }}
            </h3>
          </div>
        </div>
        @if (portfolios.length) {
          <div>
            <div class="grid-table__wrapper">
              <div class="grid-table__head tw-grid tw-grid-cols-4">
                <div class="max-md:tw-col-span-2 max-sm:tw-col-span-3 lg:tw-col-span-1 lg:tw-pr-8">
                  {{ 'common.company' | translate }}
                </div>
                <div class="max-sm:tw-hidden">{{ 'settings.counter' | translate }}</div>
                <div class="max-md:tw-hidden">{{ 'common.date' | translate }}</div>
                <div class="tw-text-right">{{ 'common.action' | translate }}</div>
              </div>
            </div>
            <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-2">
              @for (portfolio of portfolios; track portfolio) {
                <div class="grid-table__body tw-grid tw-grid-cols-4 hover:tw-bg-divider/20">
                  <div
                    class="max-md:tw-col-span-2 max-sm:tw-col-span-3 lg:tw-col-span-1 lg:tw-pr-8"
                  >
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <app-thumbnail-group [imageUrl]="portfolio.company.companyLogoUrl" />
                      <div>
                        <p class="tw-m-0 tw-line-clamp-1 tw-text-sm md:tw-line-clamp-2">
                          {{ portfolio.company.name }}
                        </p>
                        <p class="tw-m-0 tw-text-sm md:tw-hidden">
                          {{
                            portfolio.digitalCert?.createdAt
                              ? (portfolio.digitalCert.createdAt | date: 'd MMM yyyy')
                              : '-'
                          }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tw-flex tw-items-center max-sm:tw-hidden">
                    <a
                      class="tw-m-0 tw-uppercase"
                      [ngClass]="showCounterLink(portfolio) ? 'tw-text-link' : 'tw-text-black'"
                      [routerLink]="
                        showCounterLink(portfolio) ? ['/pstx', portfolio.tickerCode] : null
                      "
                      routerLinkActive="router-link-active"
                    >
                      {{ portfolio.tickerCode ?? '-' }}
                    </a>
                  </div>
                  <div class="tw-flex tw-items-center max-md:tw-hidden">
                    <p class="tw-m-0 tw-text-sm">
                      {{
                        portfolio.digitalCert?.createdAt
                          ? (portfolio.digitalCert.createdAt | date: 'd MMM yyyy')
                          : '-'
                      }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center tw-justify-end !tw-pr-6">
                    <button
                      type="button"
                      title="{{ 'common.download' | translate }}"
                      class="tw-h-5 tw-w-5 tw-bg-transparent"
                      [disabled]="!portfolio.digitalCert?.url"
                      (click)="portfolio.digitalCert?.url && openUrl(portfolio.digitalCert.url)"
                    >
                      <span class="pitchin-icon-download tw-inline-block tw-h-5 tw-w-5"></span>
                    </button>
                  </div>
                </div>
              }
            </div>
            <section class="tw-flex tw-items-center tw-justify-center tw-p-4">
              <ngb-pagination
                [collectionSize]="total"
                [(pageSize)]="params.take"
                [(page)]="params.currentPage"
                (pageChange)="getDigitalCerts()"
                [maxSize]="5"
                [rotate]="true"
              >
                <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
                <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
                <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
              </ngb-pagination>
            </section>
          </div>
        } @else {
          <div class="tw-select-none tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-text-body/80">
            {{ 'settings.noDigitalCertificates' | translate }}
          </div>
        }
      </app-accordion>
    </section>
    <section class="tw-border tw-border-divider">
      <app-accordion
        [headerClass]="'tw-bg-white hover:tw-bg-divider/20 disabled:hover:tw-bg-white tw-rounded-lg tw-text-left'"
        [isDisabled]="!monthlyStatements.length"
        [isCollapsed]="monthlyStatements.length"
      >
        <div accordion-title>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img
              src="../../../../../assets/img/icons/svgs/monthly-statement.svg"
              alt="{{ 'portfolio.monthlyStatements' | translate }}"
              class="tw-h-5 tw-w-5"
            />
            <h3 class="tw-m-0 tw-font-body tw-text-sm tw-font-semibold tw-text-black">
              {{ 'portfolio.monthlyStatements' | translate }}
            </h3>
          </div>
        </div>
        <div class="tw-divide-y tw-divide-divider">
          @if (monthlyStatements.length) {
            @for (section of monthlyStatements; track section) {
              <div>
                <app-accordion [headerClass]="'tw-text-sm'" [isCollapsed]="true">
                  <div accordion-title>{{ section.year }}</div>
                  <!-- Table header -->
                  <div class="grid-table__wrapper">
                    <div class="grid-table__head tw-grid tw-grid-cols-4">
                      <div class="tw-col-span-2 tw-capitalize max-sm:tw-col-span-3 lg:tw-pr-8">
                        {{ 'common.month' | translate }}
                      </div>
                      <div class="max-sm:tw-hidden">{{ 'common.date' | translate }}</div>
                      <div class="tw-text-right">{{ 'common.action' | translate }}</div>
                    </div>
                  </div>
                  <!-- Table body -->
                  @for (statement of section.monthlyStatements; track statement) {
                    <div
                      class="grid-table__body tw-grid tw-grid-cols-4 tw-text-xs hover:tw-bg-divider/20"
                    >
                      <div
                        class="tw-col-span-2 tw-flex tw-flex-wrap tw-justify-between tw-gap-2.5 max-sm:tw-col-span-3 max-sm:tw-items-center max-sm:tw-gap-0.5 lg:tw-pr-8"
                      >
                        <div class="tw-font-semibold">
                          {{ getTransactionMonth(statement.generationDate) }}
                        </div>
                      </div>
                      <div class="max-sm:tw-hidden">
                        {{ statement?.generationDate | date: 'd MMM yyyy' }}
                      </div>
                      <div class="tw-flex tw-items-center tw-justify-end !tw-pr-6">
                        <button
                          type="button"
                          title="Download"
                          class="tw-h-5 tw-w-5 tw-bg-transparent"
                          (click)="openUrl(statement.url)"
                        >
                          <span class="pitchin-icon-download tw-inline-block tw-h-5 tw-w-5"></span>
                        </button>
                      </div>
                    </div>
                  }
                </app-accordion>
              </div>
            }
          } @else {
            <div class="tw-select-none tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-text-body/80">
              <span [innerHTML]="'settings.monthlyStatementsEmpty' | translate"></span>
            </div>
          }
        </div>
      </app-accordion>
    </section>
    <section class="tw-border tw-border-divider">
      <app-accordion
        [headerClass]="'tw-bg-white hover:tw-bg-divider/20 disabled:hover:tw-bg-white tw-rounded-lg tw-text-left'"
        [isDisabled]="!taxCertificates.length"
        [isCollapsed]="taxCertificates.length"
      >
        <div accordion-title>
          <div class="tw-flex tw-items-center tw-gap-2">
            <img
              src="../../../../../assets/img/icons/svgs/taxexemptioncerticon.svg"
              alt="{{ 'settings.taxCert' | translate }}"
              class="tw-h-5 tw-w-5"
            />
            <h3 class="tw-m-0 tw-font-body tw-text-sm tw-font-semibold tw-text-black">
              {{ 'settings.taxCert' | translate }}
            </h3>
          </div>
        </div>
        <div class="tax-highlight-container">
          <span class="tax-highlight-text"
            ><img
              src="../../../../../assets/img/icons/svgs/info-blue-icon.svg"
              alt="{{ 'common.information' | translate }}"
              class="tw-mr-1 tw-h-2 tw-w-2"
            />{{ 'settings.taxHighlightMessage' | translate }}</span
          ><span class="tax-highlight-text">{{
            'settings.learnMoreTaxIncentive' | translate
          }}</span>
          <a
            href="https://support.pitchin.my/hc/en-us/articles/34365039740957-How-do-I-file-for-ECF-Tax-Exemption"
            class="tax-highlight-link"
          >
            here</a
          >
        </div>
        @if (taxCertificates.length) {
          <div>
            <div class="grid-table__wrapper">
              <div class="grid-table__head tw-grid tw-grid-cols-4">
                <div class="max-md:tw-col-span-2 max-sm:tw-col-span-3 lg:tw-col-span-1 lg:tw-pr-8">
                  {{ 'common.company' | translate }}
                </div>
                <div class="max-sm:tw-hidden">{{ 'settings.investmentamount' | translate }}</div>
                <div class="max-md:tw-hidden">{{ 'settings.yearassement' | translate }}</div>
                <div class="tw-text-right">{{ 'common.action' | translate }}</div>
              </div>
            </div>
            <div class="tw-mt-2 tw-flex tw-flex-col tw-gap-2">
              @for (cert of displayedTaxCertificates; track cert) {
                <div class="grid-table__body tw-grid tw-grid-cols-4 hover:tw-bg-divider/20">
                  <div
                    class="max-md:tw-col-span-2 max-sm:tw-col-span-3 lg:tw-col-span-1 lg:tw-pr-8"
                  >
                    <div class="tw-flex tw-items-center tw-gap-2">
                      <div>
                        <p
                          class="tw-m-0 tw-line-clamp-1 tw-text-sm tw-font-medium tw-text-black md:tw-line-clamp-2"
                        >
                          {{ cert.issuerName }}
                        </p>
                        <p class="tw-m-0 tw-text-sm md:tw-hidden">
                          {{ cert.transactionAmount | currency }} | {{ cert.yearOfAssessment }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div class="tw-flex tw-items-center max-sm:tw-hidden">
                    <p class="tw-m-0 tw-text-sm">
                      {{ cert.transactionAmount | currency }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center max-md:tw-hidden">
                    <p class="tw-m-0 tw-text-sm">
                      {{ cert.yearOfAssessment }}
                    </p>
                  </div>
                  <div class="tw-flex tw-items-center tw-justify-end !tw-pr-3">
                    @if (cert.isPreview) {
                      <button
                        type="button"
                        title="Download"
                        class="preview-btn"
                        (click)="openReviewPopUp(cert)"
                      >
                        <span class="preview-btn-text">
                          <img
                            src="../../../../../assets/img/icons/svgs/preview-icon.svg"
                            alt="{{ 'common.preview' | translate }}"
                            class="tw-h-3.5 tw-w-3.5"
                          />{{ 'common.preview' | translate }}</span
                        >
                      </button>
                    }
                    @if (!cert.isPreview) {
                      <a (click)="downloadTaxCert(cert)">
                        <img
                          src="../../../../../assets/img/icons/svgs/download-icon.svg"
                          alt="{{ 'common.download' | translate }}"
                        />
                      </a>
                    }
                  </div>
                </div>
              }
            </div>
            <section class="tw-flex tw-items-center tw-justify-center tw-p-4">
              <ngb-pagination
                [collectionSize]="taxTotal"
                [(pageSize)]="taxParams.take"
                [(page)]="taxParams.currentPage"
                (pageChange)="onTaxPageChange($event)"
                [maxSize]="5"
                [rotate]="true"
              >
                <ng-template ngbPaginationPrevious><i class="fa fa-chevron-left"></i></ng-template>
                <ng-template ngbPaginationNumber let-page>{{ page }}</ng-template>
                <ng-template ngbPaginationNext><i class="fa fa-chevron-right"></i></ng-template>
              </ngb-pagination>
            </section>
          </div>
        } @else {
          <div class="tw-select-none tw-px-4 tw-py-2.5 tw-text-center tw-text-xs tw-text-body/80">
            {{ 'settings.noDigitalCertificates' | translate }}
          </div>
        }
      </app-accordion>
    </section>
  </div>
} @else {
  <div>
    <app-skeleton [width]="'60%'" [height]="2.5" />
    <app-skeleton />
    <app-skeleton />
    <app-skeleton [width]="'30%'" />
  </div>
}
